import { useState } from 'react';
import { confirmConfigAdditionalAction } from '../../../../../services/product-configuration.service';
import {
  TProductConfigAdditionalAction,
  IProductConfigAdditionalActionConfirmDto
} from '../../../../../types/product.configuration.types';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../utils/displayNudosStandardNotifications';
import BordOneToneIcon from '../../../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { NudosButton } from '../../../../NudosComponents';
import NudosConfirmActionModal from '../../../../NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';

import './EnrollmentStatusIndicator.scss';

interface IEnrollmentStatusIndicatorProps {
  enrollmentAction: TProductConfigAdditionalAction;
  onConfirmEnrollment: () => Promise<void>;
}

export default function EnrollmentStatusIndicator({
  enrollmentAction: { confirmedAt: isConfirmed, uuid: enrollmentActionUuid },
  onConfirmEnrollment
}: IEnrollmentStatusIndicatorProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const statusText = isConfirmed ? 'Confirmado ●' : 'Sin confirmar ●';
  const statusClass = isConfirmed ? 'confirmed' : 'unconfirmed';

  const handleConfirmEnrollment = () => setIsModalOpen(true);
  const handleCancelModal = () => setIsModalOpen(false);

  const handleConfirmModal = async () => {
    try {
      setIsSubmitting(true);
      const confirmBody: IProductConfigAdditionalActionConfirmDto = {
        uuid: enrollmentActionUuid
      };
      await confirmConfigAdditionalAction(confirmBody);
      displaySuccessNotification({
        customJSXMessage: <>Configuración confirmada con éxito</>,
        duration: 3000
      });
      setIsModalOpen(false);
      await onConfirmEnrollment();
    } catch {
      displayErrorNotification();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`enrollmentStatusIndicatorContainer ${statusClass}`}>
      <div className="statusSection">
        <span>Estado de la configuración: </span>
        <span className={`statusText ${statusClass}`}>{statusText}</span>
      </div>
      {!isConfirmed && (
        <NudosButton
          customClassName="confirmButton"
          customWidth="max-content"
          customHeight="20px"
          buttonText="Confirmar configuración"
          handleClick={handleConfirmEnrollment}
          isButtonDisabled={isSubmitting}
          isButtonLoading={isSubmitting}
          buttonIcon={<BordOneToneIcon variant="checkCircle" standardSize={14} stroke="white" />}
          iconPosition="right"
        />
      )}
      {isModalOpen && (
        <NudosConfirmActionModal
          modalText="El cliente todavía no ha confirmado la(s) configuración(es) de todas las herramientas, ¿seguro que deseas mover al estado de Activo?"
          firstButtonText="No, cancelar"
          secondButtonText="Sí, pasar a activo"
          firstButtonAction={handleCancelModal}
          secondButtonAction={handleConfirmModal}
          isLoading={isSubmitting}
        />
      )}
    </div>
  );
}
